// src/components/faq/FAQItem.js
import React, { useState } from 'react';

function FAQItem({ question, answer }) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="border-b border-primary">
      <button
        className="w-full text-left py-4 flex justify-between items-center focus:outline-none"
        onClick={() => setIsOpen(!isOpen)}
      >
        <span className="text-poppins font-semibold text-primary">
          {question || 'What is your return policy?'}
        </span>
        <span className="text-primary text-xl">{isOpen ? '−' : '+'}</span>
      </button>
      {isOpen && (
        <div className="pb-4">
          <p className="text-poppins text-primary">
            {answer ||
              'We offer a 30-day return policy for unworn, unwashed items with original tags. Please contact support@myshop.com to initiate a return.'}
          </p>
        </div>
      )}
    </div>
  );
}

export default FAQItem;